import { Component, computed, input, output } from '@angular/core';
import * as fromSeriousSystem from '@serious-system';

export type DocumentViewerZoomFactorClickedEvent = 'in' | 'out';
export type DocumentViewerZoomFactorLimitReached = 'in' | 'out' | false;

@Component({
  selector: 'squadbox-document-viewer-header',
  imports: [
    fromSeriousSystem.IconButtonDirective,
    fromSeriousSystem.UseFileTypeIconDirective,
    fromSeriousSystem.UseUIBasicIconDirective,
    fromSeriousSystem.UseHeroIconOutlineDirective,
  ],
  template: `
    <div
      grid-area="header"
      class="flex gap-4 tablet-landscape:gap-3 items-center overflow-hidden"
    >
      <svg
        [sdUseFileTypeIcon]="fileType()"
        class="size-8 tablet-landscape:size-6"
      ></svg>
      <span
        class="typo-p2 tablet-landscape:typo-p1 font-semibold text-nowrap text-ellipsis overflow-hidden"
        >{{ displayName() }}</span
      >
    </div>
    <div grid-area="actions" class="flex">
      @if (!isMobile()) {
        <button
          sdIconButton
          variant="icon"
          color="neutral"
          size="sm"
          [disabled]="zoomFactorLimitReached() === 'out'"
          (click)="zoomClicked.emit('out')"
        >
          <svg sdUseUIBasicIcon="zoom-out"></svg>
        </button>
        <button
          sdIconButton
          variant="icon"
          color="neutral"
          size="sm"
          [disabled]="zoomFactorLimitReached() === 'in'"
          (click)="zoomClicked.emit('in')"
        >
          <svg sdUseUIBasicIcon="zoom-in"></svg>
        </button>
      }
      <button
        sdIconButton
        variant="icon"
        color="neutral"
        size="sm"
        (click)="downloadClicked.emit()"
      >
        <svg sdUseHeroIconOutline="arrow-down-tray"></svg>
      </button>
      <button
        sdIconButton
        variant="icon"
        color="neutral"
        size="sm"
        (click)="closeClicked.emit()"
      >
        <svg sdUseUIBasicIcon="close"></svg>
      </button>
    </div>
  `,
  styles: [
    `
      @reference '../../../../styles.css';

      :host {
        @apply h-16 px-4;
        @apply border-b border-neutral-200;
        @apply grid grid-cols-[auto_min-content] gap-4 items-center;
        grid-template-areas: 'header actions';
      }
    `,
  ],
})
export class DocumentViewerHeaderComponent {
  public readonly filename = input<string>('Document 1');
  public readonly fileType = input<fromSeriousSystem.FileTypesIconsType>('pdf');

  protected readonly displayName = computed(() =>
    fromSeriousSystem.fileDisplayNameForTypeIcon(
      this.filename(),
      this.fileType(),
    ),
  );
  public readonly zoomFactorLimitReached =
    input<DocumentViewerZoomFactorLimitReached>(false);
  public readonly isMobile = input<boolean>(false);
  public readonly zoomClicked = output<DocumentViewerZoomFactorClickedEvent>();
  public readonly downloadClicked = output<void>();
  public readonly closeClicked = output<void>();
}
